// Filter access level requirements
// Users must have a level >= the specified value to access the filter
// Keep in sync with backend/config/filterLimitLevel.js

const filterLimitLevel = {
  // Basic filters (no level requirement)
  searchName: 0,
  ageRange: 0,
  gender: 0,

  // Level 1 filters
  isTechnical: 1,
  timing: 1,
  hasIdea: 1,

  // Level 25 filters
  location: 25,
  searchLocation: 25,
  searchAboutMe: 25,
  searchImpressiveThing: 25,
  isYcFounder: 25,
  interests: 25,
  responsibilities: 25,
  cfResponsibilities: 25,
  hasCf: 25,

  // Level 50 filters
  searchEducation: 50,
  hasCompany: 50,
  hasCompanyUrl: 50,
  searchCompany: 50,
  hasPotentialIdeas: 50,
  cfHasIdea: 50,
  cfIsTechnical: 50,
  cfLocation: 50,
  cfAgeRange: 50,
  cfIsFellowAlumniImportance: 50,
  cfIsYcAlumImportance: 50,
  cfIsWomanImportance: 50,
  searchEquity: 50,

  // Level 100 filters
  searchEmployment: 100,
  searchCompanyDescription: 100,
  searchCompanyProgress: 100,
  searchFundingStatus: 100,
  searchPotentialIdeas: 100,
  searchIdealCofounder: 100
};

export default filterLimitLevel;
